import BaseController from "./base_controller"

// Controller used as a Turbo Stream hook to close the entry modal
export default class extends BaseController {
  static values = {
    message: String
  }

  declare messageValue: string

  connect(): void {
    super.connect()

    try {
      document.dispatchEvent(
        new CustomEvent("modal-entry:close", {
          detail: { message: this.messageValue }
        })
      )
    } finally {
      // Remove helper element to keep DOM clean
      this.element.remove()
    }
  }
}

